export const REGION_IDS_CHANGE_FIELD = 'RegionIds';
export const SECTION_ID_CHANGE_FIELD = 'SectionId';

export function getChangeFieldLabel(fieldName: string): string {
  if (isMaterialChange(fieldName)) {
    return 'Material Type';
  }
  if (isRegionIdsChange(fieldName)) {
    return 'Regions';
  }
  if (isSectionIdChange(fieldName)) {
    return 'Section';
  }
  return fieldName;
}

export function getChangeValueLabel(fieldName: string, value: any, materials: any[], regions?: any[], sections?: any[]): string {
  if (isMaterialChange(fieldName)) {
    const normalizedValue = normalizeGuid(value);
    const material = (materials ?? []).find(item => normalizeGuid(item?.Guid) === normalizedValue);
    return material?.Name ?? value;
  }

  if (isRegionIdsChange(fieldName)) {
    return (value?.toString() ?? '')
      .split(',')
      .map((id: string) => id.trim())
      .filter((id: string) => id.length > 0)
      .map((id: string) => getRegionDisplayName(id, regions) ?? id)
      .join(', ');
  }

  if (isSectionIdChange(fieldName)) {
    const normalizedId = normalizeGuid(value);
    const section = (sections ?? []).find(item => normalizeGuid(item?.id) === normalizedId);
    return section?.name ?? section?.properties?.General?.Name ?? value;
  }

  return value;
}

/** Same label source as the properties window's read-only Region field. */
export function getRegionDisplayName(regionId: string, regions?: any[]): string | null {
  const normalizedId = normalizeGuid(regionId);
  const region = (regions ?? []).find(item => normalizeGuid(item?.id) === normalizedId);
  if (!region) {
    return null;
  }
  return region.properties?.General?.Description ?? region.properties?.General?.TagService ?? region.name ?? null;
}

function isMaterialChange(fieldName: string): boolean {
  return fieldName?.split('_')[0]?.toLowerCase() === 'materialid';
}

function isSectionIdChange(fieldName: string): boolean {
  return fieldName?.toLowerCase() === SECTION_ID_CHANGE_FIELD.toLowerCase();
}

function isRegionIdsChange(fieldName: string): boolean {
  return fieldName?.toLowerCase() === REGION_IDS_CHANGE_FIELD.toLowerCase();
}

function normalizeGuid(value: any): string {
  return value?.toString().replace(/-/g, '').toLowerCase() ?? '';
}
